import React, { useState, useEffect, use } from 'react';
import Step from "./step";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/UI/customButton/customButton";
import { Link, useLocation } from "react-router-dom";
import CrewStep from "./crewStep";
import WharfStep from "./wharfStep";
import FlightInformationStep from "./flightInformationStep";
import UploadStep from "./uploadStep";
import SendRequestStep from "./sendRequestStep";
import SuccessPage from "./successPage";
import FormNumberTwo from "../forms/formNumberTwo";
import { Get } from "../../../apis/api";
import { setting } from "../../../store/setting/setting.reducer";
import { useDispatch } from "react-redux";
import { useVisaRegister } from './zustand';
import { NewUploadStep } from './NewUploadStep'

const NewVisaOrder = () => {
  const [steSp, setStep] = useState(1)

  const { pathname } = useLocation()

  const { step, dispatch: dispatchStore } = useVisaRegister()
  useEffect(() => {
    dispatchStore({ step: 'SELECT_VISA', selectedVisa: undefined, currentVisaSteps: [] })
  }, [pathname])
  const [crewList, seCrewList] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    handleList()
  }, [])

  const handleList = () => {
    Get(`basic-information/city?&per_page=100`).then((res) => {
      dispatch(setting({ city: res?.details?.data?.data }))
    })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
      })


    Get(`basic-information/province?per_page=100`).then((res) => {
      dispatch(setting({ province: res?.details?.data?.data }))
    })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {

      })

  }

  console.log({ step })
  const handleSteps = () => {
    return (
      <>
        <CrewStep activeStep={step === 'SELECT_VISA'} changeStep={(e) => setStep(e)} listOfCrew={(e) => seCrewList(e)} />
        <WharfStep activeStep={step === 'DOCK_SHIP'} changeStep={(e) => setStep(e)} />
        <FlightInformationStep activeStep={step === 'FLIGHT'} changeStep={(e) => setStep(e)} />
        <NewUploadStep activeStep={step === 'UPLOAD_DOCS'} crewList={crewList} changeStep={(e) => setStep(e)} />
        <SendRequestStep activeStep={step === 'PAY'} changeStep={(e) => setStep(e)} />
        <SuccessPage changeStep={(e) => setStep(e)} activeStep={step === 'SUCCESS'} />
      </>
    )
  }
  return (
    <div className={"mb-10"}>
      {
        step !== 6 &&
        <div className={"my-container"}>
          <Step step={step} />
        </div>
      }

      {handleSteps()}
    </div>
  );
};

export default NewVisaOrder;
